import { Component, ViewChild } from '@angular/core';
import { MessageService } from './utility/service/message.service';
import { NativeStateComponent } from './utility/table/state/state.component';
import { TableColumn, DateTableColumn } from './utility/table/table.column';
import { TableComponent, DataReloadEvent } from './utility/table/table.component';
import { TableElement } from './utility/table/table.element';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'serengeti-common';

	columns = [];
	columnEditEvent: TableColumn;

	@ViewChild('nodeList', { static: true }) nodeList: TableComponent;
	currentCondition: DataReloadEvent;

  constructor(
    private messageService: MessageService
  ) {
		this.columns = [
			new TableColumn('appEventId', 'execute-type.title')
			.withIgnoreSort(true)
			.withIconDecorator((self: TableColumn, element: TableElement) => {
				const data = element.getData();

				if (data.pipelines && data.pipelines.length > 0) {
					return 'group_work';
				} else {
					if (data.parent) {
            element.styles = 'child1';

						return 'arrow_right_alt';
					} else {
						return '';
					}
				}
			})
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const data = _element.getData();
				const appEventId = TableColumn._getData(data, 'appEventId');

				if (appEventId) {
					if (data.pipelines && data.pipelines.length > 0) {
						if (data.executableType === 'ChainEvent' && data.appName) {
							return 'pipeline';
						} else {
							return 'chain';
						}
					} else {
						return 'event';
					}
				} else {
					return 'branch';
				}
			}),
			new TableColumn('status', 'status')
			.withType(NativeStateComponent)
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const state = TableColumn._getData(_element.getData(), 'status');
				const transactionOrder = _element.getData().transactionOrder;
				const execute = _element.getData();

				if (transactionOrder !== -1) {
					if (state === 'Running') {
						execute._nativeState = 'status completed';
						return 'running';
					} else if (state === 'Pending') {
						execute._nativeState = 'status pending';
						return 'pending';
					} else if (state === 'Starting') {
						execute._nativeState = 'status starting';
						return 'resource.instance.common.state.starting';
					} else if (state === 'Failed') {
						execute._nativeState = 'status failed';
						return 'failed';
					} else if (state === 'Error') {
						execute._nativeState = 'status error';
						return 'error';
					} else {
						execute._nativeState = 'status running';
						return 'completed';
					}
				} else {
					if (execute.resultCode === 'OK') {
						execute._nativeState = 'status running';
						return 'completed';
					} else if (execute.resultCode === 'Failed') {
						execute._nativeState = 'status failed';
						return 'completed';
					} else {
						execute._nativeState = 'status none';
						return 'non-executable';
					}
				}
			}),
			new DateTableColumn('startTime', 'start-time')
			.withStyles('cellCenter'),
			new TableColumn('elapsedTime', 'elapsed-time')
			.withFixed(3)
			.withStyles('cellRight')
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const elapsedTime = TableColumn._getData(_element.getData(), 'elapsedTime');

				if (elapsedTime) {
					const elapsedTimeInSeconds = elapsedTime / 1000;

					return elapsedTimeInSeconds.toLocaleString();
				} else {
					return '-';
				}
			}),
			new TableColumn('resultCode', 'result.title')
			.withType(NativeStateComponent)
			.withDecorator((_column: TableColumn, _element: TableElement) => {
				const resultCode = TableColumn._getData(_element.getData(), 'resultCode');
				const transactionOrder = _element.getData().transactionOrder;
				const execute = _element.getData();

				if (resultCode === 'OK') {
					execute._nativeState = 'status running';
					return 'ok';
				} else if (resultCode === 'Failed') {
					execute._nativeState = 'status failed';
					return 'failed';
				} else {
					if (transactionOrder !== -1) {
						const state = TableColumn._getData(_element.getData(), 'status');
						if (state === 'Running') {
							execute._nativeState = 'status completed';
							return 'running';
						} else if (state === 'Pending') {
							execute._nativeState = 'status pending';
							return 'pending';
						} else if (state === 'Starting') {
							execute._nativeState = 'status starting';
							return 'resource.instance.common.state.starting';
						} else if (state === 'Failed') {
							execute._nativeState = 'status failed';
							return 'failed';
						} else if (state === 'Error') {
							execute._nativeState = 'status error';
							return 'error';
						} else {
							execute._nativeState = 'status running';
							return 'completed';
						}
						// execute._nativeState = 'status failed';
						// return 'failed';
					} else {
						return 'non-executable';
					}
				}
			})
		];
  }

	ngOnInit() {
		this.doSearch();
	}

	doSearch() {
		this.doRefresh(new DataReloadEvent('startTime', 'asc'));
	}

	doRefresh(condition: DataReloadEvent) {
    this.messageService.query("https://serengeti.aifrica.co.kr/be.execute/backend/v1/execute/handle/transaction/df1b9f36-b6af-4a81-a673-ce6569a7fb7b/")
		.subscribe((detail: any)  => {
			if (condition) {
				this.currentCondition = condition;
			} else {
				condition = this.currentCondition;
			}
			condition.active = 'elapsedTime';

			const executes = detail.executings;

			if (executes) {
				condition.pageSize = executes.length;
			} else {
				condition.pageSize = 10;
			}

			this.nodeList.refreshData(executes, this.columns, condition, (executes: any[], sortColumn: TableColumn, condition: DataReloadEvent) => {
				executes = this.sortAndExpand(executes, this.columns, sortColumn, condition);
				condition.pageSize = executes.length;

				return executes;
			});  
		});
	}

	sortAndExpand(executes: any[], columns: TableColumn[], sortColumn: TableColumn, condition: DataReloadEvent) {
		const expandedExecutes = [];

		executes.sort((item1: any, item2: any) => {
			return this.nodeList.sortItems(item1, item2, sortColumn, condition);
		});

		executes.forEach((execute: any) => expandedExecutes.push(execute));

		executes.forEach((execute: any, index: number) => {
			if (execute.pipelines && execute.pipelines.length > 0) {
				const children = this.sortAndExpand(execute.pipelines, columns, sortColumn, condition);

				if (children.length > 0) {
					children.forEach((child: any, childIndex: number) => {
						expandedExecutes.splice(index + childIndex + 1, 0, child);
					});
				}
			}
		});

		return expandedExecutes;
	}

}
